var lx = lx || {};
lx.landing = lx.landing || {};
var lSlideSpeed = 1100;
	
/*ex function toggleNewCom*/
lx.landing.newOrg = function (pType){
    if($(".landing > #landingHdr:visible").length == 0 && $(".landing > #landingBody:visible").length == 0){
        $(".lxNewCom").hide("slide", {direction:"right"}, lSlideSpeed, function(){$(".landing > #landingHdr").show("slide", lSlideSpeed);
																				  $(".landing > #landingBody").show("slide", lSlideSpeed);
                                                                                  $('html, body').animate({scrollTop: $("#newOrg").offset().top - 70}, 10);
																				  if (pType == 'REFRESH') {location.reload();}
                                                                                 });
    }else{
        $(".landing > #landingHdr").hide("slide", lSlideSpeed, function(){$(".lxNewCom").show("slide", {direction:"right"}, lSlideSpeed);$("#ncName").focus();});
        $(".landing > #landingBody").hide("slide", lSlideSpeed, function(){$(".lxNewCom").show("slide", {direction:"right"}, lSlideSpeed);$("#ncName").focus();});
    }
};

/*ex function toggleSearch*/
var searchProfileType;
lx.landing.search = function (pType){
    if($(".landing > #landingHdr:visible").length == 0 && $(".landing > #landingBody:visible").length == 0){
        $("#searchHdr").hide("slide", {direction:"right"}, lSlideSpeed, function(){
                                                                            $(".landing > #landingHdr").show("slide", lSlideSpeed);
																			$(".landing > #landingBody").show("slide", lSlideSpeed);
                                                                            $('html, body').animate({scrollTop: $("#lxBtn").offset().top - 70}, 10);
                                                                            $(".lxSearchALL #lxSearchResults").html('<div class="msgTxt">Please enter at least <b>3 characters</b>!</div>');
                                                                            $("#searchHdr input").val("");
																			$("#lxSearchResults").html("")
                                                                        });
    }else{
        $(".landing > #landingHdr").hide("slide", lSlideSpeed, function(){$("#searchHdr").show("slide", {direction:"right"}, lSlideSpeed, function(){$("#searchHdr").find("input").focus();});});
        $(".landing > #landingBody").hide("slide", lSlideSpeed, function(){$("#searchHdr").show("slide", {direction:"right"}, lSlideSpeed, function(){$("#searchHdr").find("input").focus();});});
    }
};
/* ex searchProfile function*/
var searchTimer;
lx.landing.searchProfile = function (pThis, pType, pPage) {
    var lPage = 1, lValue;
    var $container = $(pThis).closest("#searchHdr");
    if (pThis.id == "LX_SEARCH") {
        lValue = pThis.value;
        $container.find(".lxSearchResultsCont").show();
        $("#uOneCol, #uFooter").hide();
    } else if (pPage) {
        lPage = pPage;
        lValue = $container.find("input").val();
    } else {
        lValue = pThis.value;
    }
    clearTimeout(searchTimer);
    if (lValue.length < 3) {
		null;
    } else {
        searchTimer = setTimeout(function () {
            lxLoad();
            apex.server.process("profileSearch", {
                x01: lValue,
                x02: pType,
                x03: lPage
            }, {
                    dataType: "text",
                    success: function (pData) {
                        $container.find("#lxSearchResults").html(pData);
                        lx.load.remove();
                    }
                });
        }, 500);
    }
};

lx.landing.searchProfile2 = function (pThis, pType, pPage) {
	/*alert(document.getElementById("goID").value);*/
    var lPage = 1, lValue;
    var $container = $("#goID").closest("#searchHdr");
    lValue = document.getElementById("goID").value;
    //clearTimeout(searchTimer);
    if (lValue.length < 3) {
		null;
    } else {
        //searchTimer = setTimeout(function () {
            lxLoad();
            apex.server.process("profileSearch", {
                x01: lValue,
                x02: pType,
                x03: lPage
            }, {
                    dataType: "text",
                    success: function (pData) {
                        $container.find("#lxSearchResults").html(pData);
                        lx.load.remove();
                    }
                });
        //}, 500);
    }
};

/* ex closeSearchResults function*/
lx.landing.closeSearchResults = function (pThis) {
    $(pThis).closest(".lxSearch").find(".lxSearchResultsCont").hide();
    $("#uOneCol, #uFooter").show();
};

var inviteForm = {
    data: {},
    profIndex: 0,
    html: null,
    loadData: function (pContacts) {
        var self = this;
		apex.server.process("inviteJson", {
			x01: pContacts
			}, {
				dataType: "json",
				success: function (r) {
					self.data = r;
					self.openPopup();
				}
			}
		);
    },
    openPopup: function () {
        var formHtml = '<div class="inviteForm"><div class="hdr"></div><div class="cont1"><h1>Linxpot Invitation</h1><p>Invite other people to Linxpot on behalf of</p><select id="inv_behalf" onchange="inviteForm.changeProfile();">';
        for (var i = 0; i < this.data.profs.length; i++) {
            formHtml += '<option value="' + this.data.profs[i].id + '"';
            if (this.data.curProf == this.data.profs[i].id) {
                formHtml += ' selected';
                this.profIndex = i;
            }
            formHtml += '>' + this.data.profs[i].name + '</option>';
        }
        formHtml += '</select><div class="invCon"><p>to become</p><select id="inv_con" onchange="inviteForm.changeConnection();">';
        if (this.data.profs[this.profIndex].type == 'COM') formHtml += '<option value="EMP">Employee</option>';
        if (this.data.profs[this.profIndex].subs.length > 0) formHtml += '<option value="SUB">Member</option>';
        formHtml += '<option value="CLI">Connection</option></select></div><div class="invMem">';
        formHtml += '</div><div class="btnContainer"><div class="lxBtn" onclick="$(\'.inviteForm\').dialog(\'destroy\');">Cancel</div>' +
            '<div class="lxBtn hot" onclick="inviteForm.nextStep();">Next</div></div>' +
            '</div><div class="cont2" style="display:none;"><table><thead><tr><th>First Name</th><th>Last Name</th><th>Email</th></tr></thead><tbody>';
        for (var i = 0; i < this.data.invites.length; i++) {
            formHtml += this.addRow(this.data.invites[i]);
        }
        /* formHtml += '</tbody></table><div class="btnContainer"><div class="lxBtn blue" onclick="inviteForm.invite();">Invite to Linxpot</div>'+
                     '<div class="lxBtn hot" onclick="inviteForm.addRow();">ADD ROW</div>'+
                     '<div class="lxBtn hot" onclick="inviteForm.importXLS();">IMPORT CONTACT LIST</div></div></div></div>';*/
        formHtml += '</tbody></table><div class="btnContainer"><div class="lxBtn hot" onclick="inviteForm.addRow();">Add Row</div>' +
            /*'<div class="lxBtn hot" onclick="inviteForm.importXLS();">Import Contact List</div>' +*/
            '<div class="lxBtn blue" onclick="inviteForm.invite();">Send Invite</div></div></div></div>';
        this.html = formHtml;
        $(this.html).dialog({
            modal: true,
            resizable: false,
            title: "",
            width: 480
        });
        this.renderSubSelect();
        //$("#inv_behalf").select2({width: "resolve"});
        if (this.data.invites.length == 0) this.addRow();
    },
    renderSubSelect: function () {
        var selectHtml = "";
        if (this.data.profs[this.profIndex].subs.length > 0) {
            for (var i = 0; i < this.data.profs[this.profIndex].subs.length; i++) {
                selectHtml += '<option value="' + this.data.profs[this.profIndex].subs[i].id + '">' + this.data.profs[this.profIndex].subs[i].name + "</option>";
            }
            selectHtml = '<p>Select Membership</p><select id="inv_sub">' + selectHtml + '</select>'
        }
        $(".invMem").html(selectHtml).hide();
        //$("#inv_sub").select2({width: "resolve"});
    },
    changeProfile: function () {
        var lProfSelected = $v("inv_behalf"), selectHtml = "";
        for (var i = 0; i < this.data.profs.length; i++) {
            if (this.data.profs[i].id == lProfSelected) {
                this.profIndex = i;
                if (this.data.profs[i].type == 'COM') selectHtml += '<option value="EMP">Employee</option>';
                if (this.data.profs[i].subs.length > 0) selectHtml += '<option value="SUB">Member</option>';
                selectHtml += '<option value="CLI">Connection</option>';
                $("#inv_con").html(selectHtml);
                //$("#inv_con").select2({width: "resolve"});
            }
        }
        this.renderSubSelect();
    },
    changeConnection: function () { if ($v("inv_con") == "SUB") $(".invMem").show(); },
    nextStep: function () {
        $(".inviteForm .cont1").hide();
        $(".inviteForm .cont2").show();
        $(".ui-dialog").css("width", "960px").css("left", "calc(50% - 480px)");
    },
    addRow: function (params) {
        if (params)
            return '<tr><td><input type="text" name="inv_fname" value="' + params.fname + '" /></td>'
                + '<td><input type="text" name="inv_lname" value="' + params.lname + '" /></td>'
                + '<td><input type="text" name="inv_email" value="' + params.email + '" />'
                + '<input type="hidden" name="inv_ius" value="' + params.ius + '" /></td></tr>';
        else $(".inviteForm table > tbody").append('<tr><td><input type="text" name="inv_fname" value="" /></td><td><input type="text" name="inv_lname" value="" /></td><td><input type="text" name="inv_email" value="" /></td></tr>');
    },
    importXLS: function () {
        var vLink = 'f?p=' + $v('pFlowId') + ':216:' + $v('pInstance') + '::NO::P216_PROFILE_ID,P216_CNCT_TYPE:' + $v('inv_behalf') + ',' + $v('inv_con') + '&' + this.data.p216_cs;
        apex.navigation.dialog(vLink, { height: '520', width: '950', maxWidth: 'false', modal: true, dialog: null }, '');
        $('.inviteForm').dialog('destroy');
    },
    invite: function () {
        var lData = [], lRow;
        var lErr = false;
		var cnt = 0;
		$('div[id*=error_placeholder]').remove();
		apex.message.clearErrors();
        $(".container #invRow").each(function () {
			cnt++;	
			//alert(cnt+"-"+gRowNum);		
			var fname = $(this).find("input[name=inv_fname_"+cnt+"]").val().replace("|", "").replace("~", "");
			var lname = $(this).find("input[name=inv_lname_"+cnt+"]").val().replace("|", "").replace("~", "");
			var email = $(this).find("input[name=inv_email_"+cnt+"]").val().replace("|", "").replace("~", "");
			lRow = fname + "|" + lname + "|" + email + "|" + $(this).find("input[name=inv_ius_"+cnt+"]").val();	
		//	if (lRow != "|||" && lRow != "|||undefined") {
				if (fname != "" && email != "") {lData.push(lRow);}
				else {
					if (fname == "") {
						lErr = true;
						//apex.message.clearErrors();
						apex.message.showErrors([
							{
								type:       "error",
								location:   [ "inline" ],
								pageItem:   "invFname_"+cnt,
								message:    lx.tran.get("FIRST_NAME_REQUIRED"),
								unsafe:     false
							}
						]);
					}
					if (email == "") {
						lErr = true;
						//apex.message.clearErrors();
						apex.message.showErrors([
							{
								type:       "error",
								location:   [ "inline" ],
								pageItem:   "invEmail_"+cnt,
								message:    lx.tran.get("EMAIL_REQUIRED"),
								unsafe:     false
							}
						]);
					}
				}
		//	}
        });
        //if (lErr || lData.length == 0) { return; }
		//alert($v("P33_BEHALF_OF") +"-"+$v("P33_TO_BECOME")+"-"+lData.join("~"));
		if (lErr === false && lData.length != 0) {
			gRowNum=0;
			apex.server.process("inviteSubmit", {
				x01: $v("P33_BEHALF_OF"),
				x02: $v("P33_TO_BECOME"),
				x03: $v("P33_SUB_TYPE"),
				x04: lData.join("~")
			}, {
				dataType: "html",
				success: function (d) {
					var ret = d;
					var result = ret.split("~");
					if (result[0]=='NOK') {
						apex.message.clearErrors();
						apex.message.showErrors([
						  {
							type: apex.message.TYPE.ERROR,
							location: ["page"],
							message: result[1],
							unsafe: false
						  }
						]);
						
					} else {
						$('div[id*=invRow]').remove();
						$('#lxSend').remove();
						$('#AddBtn').remove();
						$('#ResetBtn').remove();
						apex.message.showPageSuccess(result[1]);
					}
					//$(".inviteForm .cont2").html(d + '<div class="btnContainer"><div class="lxBtn" onclick="$(\'.inviteForm\').dialog(\'destroy\');">Close</div></div>');
				}
			});
		}
    }
};